import { Button } from "@/components/ui/button";
import { Body } from "@hypercard/web-components";
import { CaretLeft } from "@phosphor-icons/react";

interface Props {
  onClick: () => void;
  disabled?: boolean;
  text?: string;
}

export const SheetBackButton = ({
  onClick,
  disabled,
  text = "Back",
}: Props) => {
  return (
    <Button
      variant="secondary"
      onClick={onClick}
      disabled={disabled}
      className="absolute left-sheet-gap top-sheet-gap h-[unset]"
    >
      <CaretLeft weight="bold" className="mr-2 size-3" />
      <Body size="sm" weight="medium">
        {text}
      </Body>
    </Button>
  );
};
